"use client";

import { useEffect, useRef } from "react";
import Link from "next/link";

const therapies = [
  { name: "Massagem Terapêutica", desc: "Alívio de tensões musculares e recuperação do corpo.", icon: "💆" },
  { name: "Massagem Relaxante", desc: "Redução do estresse e promoção do bem-estar profundo.", icon: "🌸" },
  { name: "Massagem Estética", desc: "Modelagem corporal e melhora da circulação.", icon: "✨" },
  { name: "Ventosaterapia", desc: "Técnica milenar para drenagem e alívio de dores.", icon: "🌀" },
  { name: "Aromaterapia", desc: "Equilíbrio emocional com óleos essenciais naturais.", icon: "🌿" },
  { name: "Reiki", desc: "Harmonização da energia vital para corpo e mente.", icon: "🔮" },
];

export default function TerapiasPreview() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.08 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-32 md:py-44 px-6 md:px-10 relative overflow-hidden" style={{ background: 'var(--forest)' }} ref={ref}>
      {/* Subtle radial glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full opacity-10 pointer-events-none"
        style={{ background: 'radial-gradient(circle, var(--sage) 0%, transparent 70%)', transform: 'translate(30%, -30%)' }} />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-8 pointer-events-none"
        style={{ background: 'radial-gradient(circle, var(--gold) 0%, transparent 70%)', transform: 'translate(-30%, 30%)' }} />

      <div className="max-w-8xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <span className="reveal-hidden text-xs uppercase tracking-widest font-semibold mb-5 block" style={{ color: 'var(--gold)' }}>
            Terapias Integrativas
          </span>
          <h2 className="reveal-hidden reveal-delay-1 font-serif text-cream leading-tight mb-6"
            style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)' }}>
            Cuidado completo para{" "}
            <span className="italic font-light" style={{ color: 'var(--sage-light)' }}>corpo e mente</span>
          </h2>
          <span className="section-rule mx-auto" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
          {therapies?.map((therapy, i) => (
            <div
              key={therapy?.name}
              className={`therapy-item reveal-hidden reveal-delay-${(i % 3) + 1} rounded-3xl p-7 cursor-pointer`}
              style={{ border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.04)' }}
            >
              <div className="flex items-start gap-5">
                {/* Icon circle */}
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 text-xl"
                  style={{ background: 'rgba(201,168,76,0.15)', border: '1px solid rgba(201,168,76,0.25)' }}>
                  {therapy?.icon}
                </div>
                <div>
                  <h3 className="font-serif text-cream mb-2" style={{ fontSize: '1.15rem' }}>{therapy?.name}</h3>
                  <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>{therapy?.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center reveal-hidden">
          <Link href="/therapies" className="btn-gold">
            Explorar todas as terapias
          </Link>
        </div>
      </div>
    </section>
  );
}